import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import defaultMedicSvg from '../../../../assets/img/next/svg/medic.svg';
import cabinetSvg from '../../../../assets/img/next/svg/cabinet.svg';
import screeningLogoSmall from '../../../../assets/img/skrinig40_52x48.svg';

import RatingBar from '../../../components/global/List/RatingBar';
import Photo from '../../../list/doctorsPageList/common/Doctor/photo';
import Appointment from '../../../../containers/Appointment';

// import AppointmentsCalendarModal from '../../../listv2/doctorsPageList/common/Doctor/appointmentsCalendarModal';

import DoctorCalendar from './DoctorCalendar';

import Description from './description';
import Indicators from './indicators';
import Education from './education';
import useDoctorApi from './api';
import Jobs from './jobs';
import { useUrlParser } from '../../../../utils/useUrlParser';

import { isMobile } from '../../../../utils/mobile';


export default function Doctor({
  description,
  doctor,
  full_name,
  indicators,
  jobs,
  photo,
  rating,
  currentDoctorSchedule,
  byDaysSchedule,
  user,
  patients,
  isModal = false,
  currentDate = null,
  currentjobId = null,
  medicalServicesId = null,
  jobDoctorScheduleDays = null,
  searchFilters,
  selectedDate,
  setSelectedDate,
  onSelectedJobIdChange,
  isSelectedDateLoading,
}) {
  
  const urlParser = useUrlParser();
  
  const [selectedJobId, setSelectedJobId] = useState(parseInt(urlParser.urlData.params?.job_id) || currentjobId || (jobs[0]?.id));
  
  const [isMobileView, setIsMobileView] = useState(isMobile());
  
  const {
    timeSlot,
    setTimeSlot,
    // isVisibleAppointmentsCalendar,
    // setIsVisibleAppointmentsCalendar,
    isDirect,
  } = useDoctorApi({ jobs });
      
    useEffect(() => {
      const handleResize = () => {
        setIsMobileView(isMobile());
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  

  const handleJobSelect = (jobId) => {
    setSelectedJobId(jobId);

    // const newUrl = new URL(window.location);
    // if (parseInt(newUrl.searchParams.get('job_id')) !== jobId && isModal === false) {
    //   newUrl.searchParams.set('job_id', jobId);
    //   newUrl.searchParams.delete('calendar_date');
    //   window.history.replaceState({}, '', newUrl);
    // }
    
  };

  useEffect(() => {
    if (selectedJobId) {
      if (typeof onSelectedJobIdChange === 'function') {
        onSelectedJobIdChange(selectedJobId);
      }
    }
  }, [selectedJobId, onSelectedJobIdChange]);

  useEffect(() => {
    const displayName = doctor.is_virtual
      ? (jobs[0]?.cabinet_name || (jobs[0]?.cabinet_num ? `Кабінет №${jobs[0].cabinet_num}` : 'Кабінет'))
      : searchFilters?.screening_40_plus
        ? `Кабінет скринінгу${jobs[0]?.cabinet_num ? ' №' + jobs[0].cabinet_num : ''}`
        : full_name;
    if (displayName) {
      const prevTitle = document.title;
      document.title = `${displayName} - Лікарі 24/7`;
      return () => { document.title = prevTitle; };
    }
  }, [full_name, doctor.is_virtual, jobs, searchFilters]);

  const jobsToDisplay = (currentjobId > 0 || urlParser.urlData.params?.job_id)
    ? jobs.filter(job => job.id === selectedJobId)
    : jobs;

  return (
    <div className={isModal ? '' : "medic-feature"}>
      <Appointment doctor={doctor} timeSlot={timeSlot} isOpen={Boolean(timeSlot)} onClose={() => setTimeSlot(null)} showSearchBtn={true} jobDoctorScheduleDays={jobDoctorScheduleDays} searchFilters={searchFilters} job={jobs.filter(job => job.id === selectedJobId)[0]} />
      <Row>
        <Col xs={{ span: 12 }} xl={6}>
          <div className="medic-feature-profile-wrapper">
            <div className="medic-feature-profile">
              <div className={`medic-feature-profile-status ${isMobileView ? 'align-items-center justify-content-center' : ''}`}>
                <Photo 
                  photo={doctor.is_virtual ? cabinetSvg : searchFilters?.screening_40_plus ? screeningLogoSmall : photo} 
                  defaultPhoto={defaultMedicSvg}
                  isScreeningLogo={doctor.is_virtual || searchFilters?.screening_40_plus}
                />
                {isMobileView && (
                  <div className="medic-feature-profile-information__title flex-grow-1 ml-2 "><b>{doctor.is_virtual ? (jobs[0]?.cabinet_name ? jobs[0].cabinet_name : jobs[0]?.cabinet_num ? `Кабінет №${jobs[0].cabinet_num}` : 'Кабінет') : searchFilters?.screening_40_plus ? `Кабінет скринінгу ${jobs[0]?.cabinet_num ? '№' + jobs[0].cabinet_num : ''}` : full_name}</b><RatingBar rating={rating} indicators={indicators} full_name={full_name} /></div>
                )}
                {!isMobileView && (
                  <RatingBar rating={rating} indicators={indicators} full_name={full_name} />
                )}
              </div>
              <div className="medic-feature-profile-information">
                {!isMobileView && (
                  <div className="medic-feature-profile-information__title">{doctor.is_virtual ? (jobs[0]?.cabinet_name ? jobs[0].cabinet_name : jobs[0]?.cabinet_num ? `Кабінет №${jobs[0].cabinet_num}` : 'Кабінет') : searchFilters?.screening_40_plus ? `Кабінет скринінгу ${jobs[0]?.cabinet_num ? '№' + jobs[0].cabinet_num : ''}` : full_name}</div>
                )}
                <Jobs jobs={jobsToDisplay} doctor={doctor} setSelectedJobId={handleJobSelect} selectedJobId={selectedJobId} />
                {jobsToDisplay.length > 1 && (<p className='jobs-more-text'><i>*</i>Звертаємо Вашу увагу, що лікар має декілька спеціальностей та/або місць роботи. Виберіть, необхідну Вам позицію.</p>)}
              </div>
            </div>

            <div className="medic-feature-profile-detail">
              <ul className="medic-feature-profile-detail-list">
                <Indicators indicators={indicators} />
                <Description description={description} />
                <Education show={false} />
              </ul>
            </div>
            <div className="medic-feature-profile-detail__data-note">
              Інформація про медичного працівника, місце надання послуг та доступний розклад відображається на підставі даних відповідного закладу охорони здоров’я у МІС «Каштан».
            </div>
          </div>
        </Col>
        {(
          <Col xs={{ span: 12 }} xl={{ span: 6 }}>
            <div className="medic-feature-schedule-wrapper">
              <div className="schedule-wrapper">
                <div className="schedule-title-wrapper">
                  <div className="schedule-title">Розклад</div>
                  {/* {currentDoctorScheduleExists && (
                    <CalendarButton showAppointmentsCalendar={() => setIsVisibleAppointmentsCalendar(true)} />
                  )} */}
                </div>

                <DoctorCalendar 
                  onOpenAppointment={setTimeSlot}
                  currentDoctorSchedule={currentDoctorSchedule}
                  byDaysSchedule={byDaysSchedule}
                  selectedJobId={selectedJobId}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  isDirect={isDirect}
                  patients={patients}
                  jobs={jobs}
                  isSelectedDateLoading={isSelectedDateLoading}
                  isModal={isModal}
                />
              </div>
            </div>
          </Col>
        )}
      </Row>
      {/* <AppointmentsCalendarModal
        doctor={doctor}
        byDaysSchedule={byDaysSchedule}
        show={isVisibleAppointmentsCalendar}
        onClose={() => setIsVisibleAppointmentsCalendar(false)}
      /> */}
    </div>
  );
}

